<template>
  <div :class="$style.layout">
    <h2 :class="$style.title">
      Classement {{ isLockedRanking ? 'définitif' : 'provisoire' }}
    </h2>
    <template v-if="posts.length">
      <div :class="[$style.grid, { [$style['grid--solo']]: isSoloContest }]">
        <ContestParticipation
          v-for="(post, i) in posts"
          :key="post.id"
          :rank="getRanking(i)"
          :participation="post"
        />
      </div>
      <div class="u-d-f u-jc-c u-ai-c">
        <ButtonSimple
          v-if="hasMorePosts"
          :label="loadingMorePost ? `Chargement...` : `Charger plus`"
          color="white"
          :outline="true"
          :disabled="loadingMorePost"
          @click="loadMorePosts"
        />
      </div>
    </template>
    <div
      v-else
      :class="$style.grid"
    >
      <p :class="$style['no-result']">Aucune participation pour le moment</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { isSoloContestKey, isLockedRankingKey } from '#imports'
const route = useRoute()

const recordContestsStore = useRecordContestsStore()
const { recordContest, posts } = storeToRefs(recordContestsStore)

const isLockedRanking = inject(isLockedRankingKey)
const isSoloContest = inject(isSoloContestKey)

const loadingMorePost = ref(false)

const hasMorePosts = computed(() => {
  return recordContest.value?.has_more_sc_posts
})

const loadMorePosts = async () => {
  loadingMorePost.value = true

  await recordContestsStore.moreRecordContestPosts({
    slug: route.params.contestName as string,
  })

  loadingMorePost.value = false
}

const getRanking = (rank: number) => {
  // Will use index since no internal data is available
  return rank + 1
}
</script>

<style lang="scss" module>
.layout {
  padding: 100px 0;
  background-color: #151b27;

  @media (min-width: 992px) {
    padding: 100px 0 150px;
  }
}

.title {
  margin-bottom: 50px;
  color: $white;
  font-family: SST;
  font-size: 24px;
  letter-spacing: 0;
  text-align: center;
  text-transform: none;

  @media (min-width: 700px) {
    font-size: 39px;
  }
}

.grid {
  display: flex;
  flex-direction: column;
  padding: 0 25px;

  @media (min-width: 1280px) {
    max-width: 1600px;
    margin: 0 auto;
  }

  &--solo {
    @media (min-width: 992px) {
      align-items: center;
    }
  }
}

.no-result {
  color: $white;
  font-size: 16px;
  text-align: center;
}
</style>
